import { defineComponent as _defineComponent } from 'vue'
import TileGridWidgetBannerTile from './tiles/TileGridWidgetBannerTile.vue';
import TileGridWidgetImageTile from './tiles/TileGridWidgetImageTile.vue';
import { chunks } from 'JS/utilities/array';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import {
	TileGridWidgetData,
	TileGridWidgetInvalidTile,
	TileGridWidgetSection,
	TileGridWidgetSectionType,
	TileGridWidgetTile,
	TileGridWidgetTileShape,
	TileGridWidgetTileType,
} from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridSection',
  props: {
    section: null,
    data: null,
    startingPromoIndex: null
  },
  setup(__props: any) {

const props = __props as {
	section: TileGridWidgetSection;
	data: TileGridWidgetData;
	startingPromoIndex: number;
}



const sectionTypeClass = computed(() => {
	return {
		'dxp-tile-grid-widget-section--primary': props.section.type === TileGridWidgetSectionType.Primary || props.section.type === TileGridWidgetSectionType.Halves,
	};
});

const tileBaseClass = 'dxp-tile-grid-widget-section__tile';

const tiles = computed(() => props.section.tiles
	.filter(isValidTile)
	.map((tile, i) => {
		const classes = {
			[tileBaseClass]: true,
			[`${tileBaseClass}--half`]: tile.shape === TileGridWidgetTileShape.Half,
			[`${tileBaseClass}--quarter`]: tile.shape === TileGridWidgetTileShape.Quarter,
			[`${tileBaseClass}--third`]: tile.shape === TileGridWidgetTileShape.Third,
			[`${tileBaseClass}--full`]: tile.shape === TileGridWidgetTileShape.Full,
			[`${tileBaseClass}--fifth`]: tile.shape === TileGridWidgetTileShape.Fifth,
		};
		const promoAttrs = createPromoDataAttributes({
			promoId: tile.linkUrl.replace('https://www.farmandfleet.com', ''),
			promoName: tile.altText,
			creativeSlot: `dxp_tile_${props.startingPromoIndex + i + 1}`,
			creativeName: 'dxp_tiles_0',
		});
		let style = '';
		if (tile.type === TileGridWidgetTileType.Banner) {
			style = cssVarsToStyleString({
				'--_tile-grid-banner-desktop-aspect-ratio': `${tile.desktopDimensions.width} / ${tile.desktopDimensions.height}`,
				'--_tile-grid-banner-tablet-aspect-ratio': `${tile.tabletDimensions.width} / ${tile.tabletDimensions.height}`,
				'--_tile-grid-banner-mobile-aspect-ratio': `${tile.mobileDimensions.width} / ${tile.mobileDimensions.height}`
			});
		}

		return {
			tile,
			classes,
			promoAttrs,
			style
		};
	}));

const rows = computed(() => chunks(props.data.tilesPerRowBySectionType[props.section.type], tiles.value));

function isValidTile(tile: TileGridWidgetTile): tile is Exclude<TileGridWidgetTile, TileGridWidgetInvalidTile> {
	return tile.type !== TileGridWidgetTileType.Invalid;
}


return { __sfc: true,props, sectionTypeClass, tileBaseClass, tiles, rows, isValidTile, TileGridWidgetBannerTile, TileGridWidgetImageTile, TileGridWidgetTileType }
}

})